import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  FieldHeader,
  FieldBody,
} from 'web-ui-components/lib/molecules/forms';
import { InputRadio } from 'web-ui-components/lib/actions/radios';

const RadioButtonGroup = ({
  name,
  title,
  description,
  supplement,
  errorMessage,
  options,
  onChange,
  selectedOption,
  disabled,
}) => (
  <Field className="u-margin-top-c">
    <FieldHeader
      name={name}
      title={title}
      description={description}
      supplement={supplement}
      validationMessage={errorMessage}
      hasError={!!errorMessage}
    />
    <FieldBody className="web-ui-components">
      {options.map((option, index) => {
        return (
          <InputRadio.Default
            key={`${name}_${index}`}
            id={`${name}_${index}`}
            label={option.label}
            onChange={() => onChange(option.value)}
            isChecked={option.value === selectedOption}
            disabled={disabled}
          />
        );
      })}
    </FieldBody>
  </Field>
);

RadioButtonGroup.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  supplement: PropTypes.string,
  options: PropTypes.array.isRequired,
  selectedOption: PropTypes.array.isRequired,
  isFullWidth: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RadioButtonGroup.defaultProps = {
  isBlock: false,
  isFullWidth: false,
  description: null,
  supplement: null,
  noIndicator: false,
  disabled: false,
};

export { RadioButtonGroup };
